/**
 * Validación de formularios de captación (demo, test VeriFactu).
 * Devuelve claves de traducción, nunca textos: el idioma lo resuelve `t()`
 * en el componente que pinta el error.
 */

export function isValidEmail(value) {
  return /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test((value || '').trim());
}

export function isValidPhone(value) {
  const clean = (value || '').replace(/[\s\-.()/]/g, '');
  return /^\+?\d{7,15}$/.test(clean);
}

/**
 * @returns {Object} errores por campo, vacío si todo es válido
 */
export function validateLeadForm(values, { notesMax = 1000 } = {}) {
  const errors = {};

  if (!(values.name || '').trim()) errors.name = 'form.required';
  if (!(values.phone || '').trim()) errors.phone = 'form.required';
  else if (!isValidPhone(values.phone)) errors.phone = 'form.phone';
  if (!(values.email || '').trim()) errors.email = 'form.required';
  else if (!isValidEmail(values.email)) errors.email = 'form.email';
  if (!(values.company || '').trim()) errors.company = 'form.required';
  if (!(values.province || '').trim()) errors.province = 'form.required';
  if ((values.notes || '').length > notesMax) errors.notes = 'form.notes';

  return errors;
}